import { ExamplePanel } from "../helpers";
import { CarouselExample } from "./carousel";
import { ListBoxExample } from "./listbox";
export const Extended = () => {
    return ExamplePanel({
        title: 'Components+',
        tabs: [{
                title: 'Carousel',
                name: 'carousel',
                link: '/#/extended/carousel',
                example: CarouselExample
            }, {
                title: 'ListBox',
                name: 'listbox',
                link: '/#/extended/listbox',
                example: ListBoxExample
            }]
    });
};
